import {
  ADD_ITEM_TO_CART_FAILURE,
  ADD_ITEM_TO_CART_REQUEST,
  ADD_ITEM_TO_CART_SUCCESS,
  GET_CART_FAILURE,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  REMOVE_CART_ITEM_REQUEST,
  REMOVE_CART_ITEM_SUCCESS,
  UPDATE_CART_ITEM_FAILURE,
  UPDATE_CART_ITEM_REQUEST,
  UPDATE_CART_ITEM_SUCCESS,
  // Guest Cart Action Types
  LOAD_GUEST_CART,
  ADD_GUEST_CART_ITEM,
  REMOVE_GUEST_CART_ITEM,
  UPDATE_GUEST_CART_ITEM,
  CLEAR_GUEST_CART,
  BULK_LIMIT_EXCEEDED,
  // Merge Action Types
  MERGE_CART_REQUEST,
  MERGE_CART_SUCCESS,
  MERGE_CART_FAILURE,
  // Clear User Cart Action Types
  CLEAR_USER_CART_REQUEST,
  CLEAR_USER_CART_SUCCESS,
  CLEAR_USER_CART_FAILURE,
} from "./ActionType";
import { LOGOUT } from "../../Auth/ActionTypes";

const initialState = {
  // Authenticated cart (backend)
  cart: null,
  loading: false,
  error: null,
  cartItems: [],

  // Guest cart (sessionStorage)
  guestCartItems: [],
  guestTotalPrice: 0,
  guestTotalDiscountedPrice: 0,
  guestTotalItem: 0,

  // Bulk limit alert
  bulkLimitMessage: null,

  // Merge state
  merging: false,
  mergeError: null,
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    // ============================================
    // AUTHENTICATED CART ACTIONS (Existing - Unchanged)
    // ============================================
    case ADD_ITEM_TO_CART_REQUEST:
      return { ...state, loading: true, error: null };
    case ADD_ITEM_TO_CART_SUCCESS:
      return {
        ...state,
        // action.payload is a single CartItem from the backend
        cartItems: [...state.cartItems, action.payload],
        loading: false,
      };
    case ADD_ITEM_TO_CART_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_CART_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CART_SUCCESS:
      return {
        ...state,
        cartItems: action.payload.cartItems,
        cart: action.payload,
        loading: false,
      };
    case GET_CART_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case REMOVE_CART_ITEM_REQUEST:
    case UPDATE_CART_ITEM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REMOVE_CART_ITEM_SUCCESS:
      return {
        ...state,
        cartItems: state.cartItems.filter(
          (item) => item.id !== action.payload
        ),
        loading: false,
      };
    case UPDATE_CART_ITEM_SUCCESS:
      return {
        ...state,
        cartItems: state.cartItems.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
        loading: false,
      };
    case REMOVE_CART_ITEM_FAILURE:
    case UPDATE_CART_ITEM_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ============================================
    // GUEST CART ACTIONS (sessionStorage)
    // ============================================
    case LOAD_GUEST_CART:
      return {
        ...state,
        guestCartItems: action.payload.guestCartItems,
        guestTotalPrice: action.payload.totalPrice,
        guestTotalDiscountedPrice: action.payload.totalDiscountedPrice,
        guestTotalItem: action.payload.totalItem,
      };

    case ADD_GUEST_CART_ITEM:
      return {
        ...state,
        guestCartItems: action.payload.guestCartItems,
        guestTotalPrice: action.payload.totalPrice,
        guestTotalDiscountedPrice: action.payload.totalDiscountedPrice,
        guestTotalItem: action.payload.totalItem,
        bulkLimitMessage: null, // Clear any previous limit message
      };

    case REMOVE_GUEST_CART_ITEM:
      return {
        ...state,
        guestCartItems: action.payload.guestCartItems,
        guestTotalPrice: action.payload.totalPrice,
        guestTotalDiscountedPrice: action.payload.totalDiscountedPrice,
        guestTotalItem: action.payload.totalItem,
      };

    case UPDATE_GUEST_CART_ITEM:
      return {
        ...state,
        guestCartItems: action.payload.guestCartItems,
        guestTotalPrice: action.payload.totalPrice,
        guestTotalDiscountedPrice: action.payload.totalDiscountedPrice,
        guestTotalItem: action.payload.totalItem,
        bulkLimitMessage: null,
      };

    case CLEAR_GUEST_CART:
      return {
        ...state,
        guestCartItems: [],
        guestTotalPrice: 0,
        guestTotalDiscountedPrice: 0,
        guestTotalItem: 0,
      };

    case BULK_LIMIT_EXCEEDED:
      return {
        ...state,
        bulkLimitMessage: action.payload,
      };

    // ============================================
    // CART MERGE ACTIONS
    // ============================================
    case MERGE_CART_REQUEST:
      return {
        ...state,
        merging: true,
        mergeError: null,
      };

    case MERGE_CART_SUCCESS:
      return {
        ...state,
        merging: false,
        // Update cart with merged data from backend
        cart: action.payload,
        cartItems: action.payload.cartItems || [],
        mergeError: null,
      };

    case MERGE_CART_FAILURE:
      return {
        ...state,
        merging: false,
        mergeError: action.payload,
      };

    // ============================================
    // CLEAR USER CART ACTIONS
    // ============================================
    case CLEAR_USER_CART_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_USER_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        cart: { ...state.cart, totalItem: 0, totalPrice: 0, totalDiscountedPrice: 0, cartItems: [] },
        cartItems: [],
      };

    case CLEAR_USER_CART_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ============================================
    // LOGOUT - Reset all cart state
    // ============================================
    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default cartReducer;
